import * as Yup from "yup";

export const conditionGroupsSchema = Yup.array()
  .of(
    Yup.object().shape({
      conditions: Yup.array()
        .of(
          Yup.object().shape({
            value: Yup.number()
              .typeError("value must be a number")
              .required("value is required"),
            comparisonOperator: Yup.string().required(
              "comparisonOperator is required"
            ),
            environmentalVariableId: Yup.number().required(
              "environmentalVariableId is required"
            ),
          })
        )
        .min(1, "each group must have at least one condition"),
      groupOperator: Yup.string(),
      conditionOperator: Yup.string().required("conditionOperator is required"),
    })
  )
  .min(1, "at least one condition group is required");
